import React from 'react';
import { DynamicDashboard } from '@/shared/components/dashboard';
import { useAuth } from '@/features/auth/hooks/useAuth';

export const DGDashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <DynamicDashboard
      title={`Bienvenue, ${user?.firstName} ${user?.lastName}`}
    />
  );
};
